<div class="mat-table-container">
  <mat-card-title class="mat-card-title">
    <mat-toolbar class="mat-tool-bar">
      Diagnostics - Document Results
      <span class="subtitle"><i>Session ID:</i> {{sessionId}}</span>
    <mat-form-field id="filter-container" floatPlaceholder="never">
    <input id="filter-input" matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>
    </mat-toolbar>
  </mat-card-title>

    <mat-table [dataSource]="documentResultsDataSource" matSort>
      <ng-container matColumnDef="userId">
        <mat-header-cell *matHeaderCellDef>User Id</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.userId}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="client">
        <mat-header-cell *matHeaderCellDef>Client</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.client}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="schoolCode">
        <mat-header-cell *matHeaderCellDef>Site Code</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.schoolCode}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="districtCode">
        <mat-header-cell *matHeaderCellDef>District<br>Code</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.districtCode}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="testFamily">
        <mat-header-cell *matHeaderCellDef>Test<br>Family</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.testFamily}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="materialId">
        <mat-header-cell *matHeaderCellDef>Material Id</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.materialId}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="formId">
        <mat-header-cell *matHeaderCellDef>Form Id</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.formId}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.status}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="error">
        <mat-header-cell *matHeaderCellDef>Error</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.error}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="lithocode">
        <mat-header-cell *matHeaderCellDef>Lithocode</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.lithocode}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="demographicResults">
        <mat-header-cell *matHeaderCellDef class="mat-header-cell-centered">Demo. <br>Results</mat-header-cell>
        <mat-cell *matCellDef="let result;"><button mat-button ecaThrottleClick (throttleClick)="openDialog('Demographic Results', JSON.stringify(result.demographicResults, null, 2));">View</button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="inputResults">
        <mat-header-cell *matHeaderCellDef class="mat-header-cell-centered">Input <br>Results</mat-header-cell>
        <mat-cell *matCellDef="let result;"><button mat-button ecaThrottleClick (throttleClick)="openDialog('Input Results', JSON.stringify(result.inputResults, null, 2));">View</button></mat-cell>
      </ng-container>
      <ng-container matColumnDef="scoringPayload">
        <mat-header-cell *matHeaderCellDef class="mat-header-cell-centered">Scoring<br>Payload</mat-header-cell>
        <mat-cell *matCellDef="let result;"><button mat-button ecaThrottleClick (throttleClick)="openDialog('Scoring Payload', JSON.stringify(result.scoringPayload, null, 2));">View</button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="json">
        <mat-header-cell *matHeaderCellDef class="mat-header-cell-centered">JSON</mat-header-cell>
        <mat-cell *matCellDef="let result"><button mat-button ecaThrottleClick (throttleClick)="openDialog('Document Results', JSON.stringify(result, null, 2));">View</button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="debug">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let result;">
          <button mat-button
                  matTooltip="Debug"
                  class="icon"
                  ecaThrottleClick
                  (throttleClick)="debug(result)">
            <mat-icon>bug_report</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="rescore">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let result;">
          <button mat-button
                  matTooltip="Re-Score"
                  matTooltipClass="tooltip-red"
                  class="icon"
                  ecaThrottleClick
                  (throttleClick)="reScore(result)">
            <mat-icon>replay</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="documentResultColumnsToDisplay"></mat-header-row>
      <mat-row *matRowDef="let row; columns: documentResultColumnsToDisplay"></mat-row>
    </mat-table>

<a mat-raised-button [routerLink]="['./scans']">View scans</a>
</div>
